import React from 'react';

const Paragraph = ({content, className}) => {
    return <p className={className} dangerouslySetInnerHTML={{__html: content}}></p>;
}

export default Paragraph;